module.exports = __webpack_public_path__ + "static/img/hh-victim1.5ad80c8a.png";